import { Kuzzle, WebSocket, Http } from 'kuzzle-sdk/dist/kuzzle'

// TODO to common
const backendName = process.env.VUE_APP_BACKEND
  ? process.env.VUE_APP_BACKEND
  : 'local'

const instantiateKuzzleSDK = (backends, protocolType) => {
  const backend = backends[backendName] ? backends[backendName] : null

  if (!backend) {
    throw new Error(`Unable to find backend ${backendName}`)
  }

  if (!backend.host || !backend.options) {
    throw new Error(`Backend ${backendName} is malformed`)
  }

  let kuzzle = {}

  if (protocolType === 'HTTP') {
    kuzzle = new Kuzzle(new Http(backend.host, backend.options), {
      cookieAuth: true,
    })
  } else {
    kuzzle = new Kuzzle(new WebSocket(backend.host, backend.options), {
      cookieAuth: true,
    })
  }

  return kuzzle
}

const backendURL = (backends) => {
  const backend = backends[backendName] ? backends[backendName] : null
  if (backendName === 'local') {
    return `http://${backend.host}:${backend.options.port}/`
  }
  return `https://${backend.host}:${backend.options.port}/`
}

const VueKuzzle = {
  install(Vue, options) {
    Vue.prototype.$kuzzleUrl = backendURL(options.backends)
    Vue.prototype.$kuzzle = instantiateKuzzleSDK(options.backends)
    Vue.prototype.$kuzzleHttp = instantiateKuzzleSDK(options.backends, 'HTTP')
    Vue.prototype.$backendName = process.env.VUE_APP_BACKEND
      ? process.env.VUE_APP_BACKEND
      : 'local'
  },
}

export default VueKuzzle
